import * as Tone from 'tone';

class NESNoiseSynth extends Tone.Noise {
    constructor(options) {
        super({ type: 'white' });
        
        // Create a WaveShaper to quantize the signal to 4-bit
        this._bitCrusher = new Tone.WaveShaper((input) => {
            // Quantize to 16 levels (4-bit)
            const levels = 16;
            return Math.round(input * (levels - 1)) / (levels - 1);
        });

        // Create a bandpass filter to shape the noise more like NES
        this._filter = new Tone.Filter({
            type: "bandpass",
            frequency: 2000,
            Q: 1.5
        });

        // Create an envelope for shaping the sound
        this._envelope = new Tone.AmplitudeEnvelope({
            attack: 0.005,
            decay: 0.1,
            sustain: 0,
            release: 0.1
        });

        // Connect the audio chain
        this.chain(
            this._bitCrusher,
            this._filter,
            this._envelope,
            Tone.Destination
        );

        // Initialize with options
        const mergedOptions = { ...options };
        this.set(mergedOptions);

        // Keep noise running continuously — envelope handles gating
        this.start();
    }

    triggerAttackRelease(duration, time, velocity = 1) {
        duration = this.toSeconds(duration);
        this._envelope.triggerAttackRelease(duration, time, velocity);
    }

    // Method to set the noise type (mode)
    setMode(mode) {
        if (mode === "metallic") {
            this._filter.frequency.value = 2400;
            this._filter.Q.value = 2;
        } else {
            this._filter.frequency.value = 2000;
            this._filter.Q.value = 1.5;
        }
    }
}

// Function to create a pool of NES noise synthesizers
function createNESNoisePool(size = 8) {
    return Array(size).fill(null).map(() => {
        const noiseSynth = new NESNoiseSynth();
        noiseSynth.volume.value = -22; // Match original volume
        return noiseSynth;
    });
}

export { NESNoiseSynth, createNESNoisePool };